export enum routes {
    HOME = '/accueil',
    HOMEBLANK = '/',
    DOMAINES = '/domaines',
    ADMISSION = '/admission',
    RESEARCH = '/research',
    ACTIVITIES = '/activities',
    CENTRES = '/centres',
    ARTICLES = '/articles',
    ARTICLESDETAILS = '/article',
    CONTACTS = '/contacts',
    FAQ = '/faq',
    PROFILE = '/profile',

    ABOUT = '/about',
    COMPLAINTS = 'https://plaintes.ulpgl.net',
    TFE = 'https://sgt.ulpgl.net',
    LIBRARY = 'https://bibliotheque.ulpgl.net',
    BIBLIO = '/bibliotheque',
    RESSOURCES = '/ressources',
    KAUTA = '/ecole-primaire-kauta',
    METANOIA = '/ecole-secondaire-metanoia',
    KAUTA_MATERNEL = '/ecole-maternelle-kauta',
    ANCIENS = '/anciens-de-lulpgl',
    DASHBOARD = '/dashboard',
    LOGIN = '/login',
    FORGOT_PASSWORD = '/forgot-password',
    RESET_PASSWORD = '/reset-password',
    SEARCH = '/search',
    FACULTIES = '/facultes',
    SCHEDULES = '/horaires',
    EVENTS = '/evenements',
    TENDERS = '/appels-offres',
    SPECIAL_PROGRAMS = '/programmes-speciaux',
    ADMIN = '/admin',
    AUMONERIE = '/aumonerie-universitaire',
    PARTNERS = '/partenaires',
    FRAIS = '/frais-academiques',
    GUIDE_INSCRIPTION = '/guide-inscription'
}